module.exports = __webpack_public_path__ + "static/media/floorball.3f5d3b7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/floorball.svg
// module id = 376
// module chunks = 7